"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, CheckCircle } from "@untitledui/icons";
import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/base/buttons/button";
import { WatchDemoButton } from "@/components/base/buttons/watch-demo-button";
import { LINKS } from "@/consts/global";
import { cx } from "@/utils/cx";
const PERKS = ["See 7-Day and 30-Day APRs", "Analyze Price Ranges", "Estimate Your Income", "... and More!"] as const;
interface LockedInsightsGateProps {
  isLoggedIn: boolean;
  className?: string;
}
export function LockedInsightsGate(t0) {
  const $ = _c(16);
  const {
    isLoggedIn,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex h-full w-full min-w-0 items-center justify-center overflow-x-hidden overflow-y-auto border-l border-border-secondary px-6 py-4", "bg-[linear-gradient(191deg,rgb(255_255_255)_0%,rgb(248_251_255)_42%,rgb(226_238_252)_100%)]", "dark:bg-[linear-gradient(191deg,rgb(19_22_27)_0%,rgb(22_34_58)_38%,rgb(12_22_40)_100%)]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative h-[234px] w-full max-w-[308px] shrink-0 overflow-hidden rounded-xl bg-secondary ring-1 ring-border-secondary dark:bg-gray-900/80 dark:ring-border-secondary"><Image src="/images/unlock-panel-optimize.png" alt="" fill={true} className="object-cover object-center dark:brightness-[0.92] dark:contrast-[1.05]" sizes="308px" loading="eager" priority={true} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="font-display text-display-sm font-extrabold text-pretty text-text-primary">Create a Unilytics<br />Pro Account</h3>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex w-full flex-col gap-4 text-left">{t3}<ul className="flex flex-col gap-2">{PERKS.map(_temp)}</ul></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <WatchDemoButton size="lg" color="secondary" className="w-full justify-center" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = isLoggedIn ? "See Plans & Pricing" : "Create My Account";
  let t7;
  if ($[6] !== t6) {
    t7 = <Button color="primary" size="lg" href={LINKS.Plans.href} iconTrailing={ArrowRight} className="w-full justify-center">{t6}</Button>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isLoggedIn) {
    t8 = !isLoggedIn && <Link {...LINKS.Login} className="inline-flex w-full items-center justify-center py-1 text-md font-semibold text-text-tertiary transition-colors hover:text-text-secondary">Log In</Link>;
    $[8] = isLoggedIn;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <div className="flex w-full max-w-[406px] min-w-0 flex-col items-center gap-4">{t2}{t4}<div className="flex w-full flex-col gap-2">{t5}{t7}{t8}</div></div>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t1 || $[14] !== t9) {
    t10 = <div className={t1}>{t9}</div>;
    $[13] = t1;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}
function _temp(label) {
  return <li key={label} className="flex gap-3 text-md text-text-primary"><CheckCircle className="mt-0.5 size-6 shrink-0 text-fg-brand-secondary" aria-hidden={true} /><span>{label}</span></li>;
}